import React from 'react';

import { makeStyles } from '@styles/makeStyles';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material';

import NavigationLink from './navigation-link';

const useStyles = makeStyles()((theme, _params, classes) => {
  const { text, background, icon } = theme.palette.navigationDrawer;
  return {
    listItemRoot: {
      color: text.base,
      padding: theme.spacing(0.5, 2),
      flex: 'none',

      '&:hover': {
        backgroundColor: background.hover,
        color: text.hover
      }
    },
    listItemRootClosed: {
      justifyContent: 'center'
    },
    listItemSelected: {
      '&.MuiListItemButton-root': {
        backgroundColor: background.selected,
        color: `${text.selected}`
      },

      [`& .${classes.listItemIconRoot}`]: {
        color: icon.selected
      }
    },
    listItemIconRoot: {
      color: icon.base,
      minWidth: 40,
      [`&.${classes.listItemIconRootClosed}`]: {
        minWidth: 'auto'
      }
    },
    listItemTextRoot: {
      display: 'flex',
      alignItems: 'baseline'
    },
    listItemIconRootClosed: {},
    listItemTextClosed: {
      display: 'none'
    }
  };
});

const DrawerItem = ({
  children,
  disabled,
  icon,
  isActive,
  isDrawerOpen,
  linkTo,
  onClick,
  sx
}) => {
  const { classes, cx } = useStyles();
  if (!linkTo) return null;

  return (
    <Tooltip
      placement="right"
      title={isDrawerOpen ? '' : children}
      disableHoverListener={isDrawerOpen}
    >
      <ListItemButton
        classes={{
          root: cx(classes.listItemRoot, {
            [classes.listItemRootClosed]: !isDrawerOpen
          })
        }}
        sx={[...(Array.isArray(sx) ? sx : [sx]), { '&.Mui-disabled': { opacity: 0.75 } }]}
        disabled={disabled}
        component={NavigationLink}
        isActive={isActive}
        to={linkTo}
        onClick={onClick}
        activeClassName={classes.listItemSelected}
        aria-label={children}
      >
        <ListItemIcon
          classes={{
            root: cx(classes.listItemIconRoot, {
              [classes.listItemIconRootClosed]: !isDrawerOpen
            })
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          classes={{
            root: cx(classes.listItemTextRoot, {
              [classes.listItemTextClosed]: !isDrawerOpen
            })
          }}
          primary={children}
          secondary={
            disabled ? (
              <Typography
                sx={{ ml: 1, textTransform: 'uppercase', color: 'grey.600' }}
                component="span"
                variant="caption"
              >
                Coming Soon!
              </Typography>
            ) : (
              false
            )
          }
          primaryTypographyProps={{ color: 'inherit' }}
        />
      </ListItemButton>
    </Tooltip>
  );
};

export default DrawerItem;
